<script lang="ts">
  import { fade } from 'svelte/transition';
</script>

<div class="blog-skeleton-loader-container">
  <div class="skeleton-item" in:fade></div>
  <div class="skeleton-item" in:fade></div>
  <div class="skeleton-item" in:fade></div>
  <div class="skeleton-item" in:fade></div>
  <div class="skeleton-item" in:fade></div>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .blog-skeleton-loader-container {
    display: flex;
    gap: 24px;
    min-height: 600px;
    margin: 24px;
    width: max-content;
    .skeleton-item {
      height: auto;
      width: 440px;
      background-color: $color-grey-border;
      border-radius: 24px;
      @include desktop-max-width {
        width: 164px;
      }
    }
  }
</style>
